import { isDevelopment } from "./isDevelopment";

export function dbg(label: string, key?: string, color?: string, ...details: any[]) {
    if(isDevelopment) {
        console.groupCollapsed(`%c${label}: %c[${key}]`, `color: ${color};`, 'color: inherit;');
        (details || []).forEach(d => console.error(d));
        console.groupEnd();
    }
}
